module.exports = __webpack_public_path__ + "static/media/NunitoSans-Regular.b6fa052a.woff";